import { Button } from "@chakra-ui/react";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import QRCode from "qrcode";
import { useDispatch } from "react-redux";
import { getAllStudentForCsvsRequest } from "../../../modules/admin-modules/students/Actions";

// const users = [
//   {
//     username: "Radwa Elsayed",
//     phone: "+201234567890",
//     qrData: "https://example.com/1",
//   },
//   {
//     username: "Mohamed Ali",
//     phone: "+201987654321",
//     qrData: "https://example.com/2",
//   },
// ];

export default function ExportUsersButton() {
  const exportUsersWithQR = async (data) => {
    console.log(data);
    const users = data?.map((val) => ({
      ...val,
      qrData: `https://asquera.com/scan-code/${val?.id}/attendence`,
    }));
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Users");

    // Set column headers
    worksheet.columns = [
      { header: "name", key: "name", width: 25 },
      { header: "Username", key: "user_name", width: 25 },
      { header: "Phone", key: "phone", width: 20 },
      { header: "parent phone", key: "parent_phone", width: 20 },

      { header: "QR Code", key: "qr", width: 30 },
    ];

    // Start inserting rows and images
    for (let i = 0; i < users.length; i++) {
      const user = users[i];
      const rowIndex = i + 2; // +2 because row 1 is header

      // Add text values
      worksheet.getCell(`A${rowIndex}`).value = user.name;

      worksheet.getCell(`B${rowIndex}`).value = user.user_name;
      worksheet.getCell(`C${rowIndex}`).value = user.phone;
      worksheet.getCell(`D${rowIndex}`).value = user.parent_phone;

      // Generate QR Code as base64 image
      const qrDataUrl = await QRCode.toDataURL(user.qrData);

      // Add QR Code as image
      const imageId = workbook.addImage({
        base64: qrDataUrl,
        extension: "png",
      });

      // Insert image to column C
      worksheet.addImage(imageId, {
        tl: { col: 4, row: rowIndex - 1 }, // C row
        ext: { width: 100, height: 100 },
      });

      // Increase row height for QR display
      worksheet.getRow(rowIndex).height = 80;
    }

    // Write and save file
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(blob, "users_with_qr.xlsx");
  };
  const dispatch = useDispatch();
  const success = (data) => {
    exportUsersWithQR(data);
  };

  const handelClick = () => {
    dispatch(getAllStudentForCsvsRequest(success));
  };

  return <Button onClick={handelClick}>Export Users with QR</Button>;
}
